import moment from 'moment'

import { OnSchedHelpers }  from '../utils/OnSchedHelpers';
import { OnSchedTemplates } from '../OnSchedTemplates';


const calendarLoaderTmpl = `
  <div class="onsched-full-calendar-loader">
    <div class="lds-ring">
      <div></div>
      <div></div>
      <div></div>
    <div></div>
  </div></div>
`

export const CalendarTmpl = () => `
  ${calendarLoaderTmpl}
  <div id="onsched-full-calendar-toast-container"></div>
  ${calendarToolbar}
  <div id="onsched-full-calendar"></div>
  <div id="onsched-full-calendar-pagination"></div>
`

const calendarToolbar = `
  <div class="onsched-fc-toolbar" id="fc-toolbar">
    <div class="fc-left fc-toolbar-group">
      <button title="Refresh calendar" class="fc-refetch" data-toolbaraction="refetchEvents"><i class="fas fa-redo"></i></button>
      
      <h5 id="fc-header-toolbar-day"></h5>

      <button title="Previous date" type="button" data-toolbaraction="prev">
        <i class="fas fa-chevron-left"></i>
      </button>
      <button title="Next date" type="button" data-toolbaraction="next">
        <i class="fas fa-chevron-right"></i>
      </button>
    </div>
    <div class="fc-center fc-toolbar-group">
      <h5 title="Jump to today" data-toolbaraction="today" id="fc-header-toolbar-date"></h5>
    </div>
    <div class="fc-right fc-toolbar-group onsched-form">
      <div class="onsched-select">
        <select title="Change view">
          <option value="resourceTimeGridDay">Day</option>
          <option value="timeGridWeek">Week</option>
          <option value="dayGridMonth">Month</option>
        </select>
      </div>
    </div>
  </div>
`

export const CalendarResources = resources => 
  resources.map(resource => `
    <li class="onsched-calendar-resource">
      <div class="initials-icon" data-id="${resource.id}">
        ${resource.extendedProps.imageUrl ? `
          <img src="${resource.extendedProps.imageUrl}" />
        `: `
          <h5>${resource.title.split(' ').map(t => t.slice(0,1).toUpperCase()).join('').slice(0,2)}</h5>
        `}
      </div>

      <div>
        ${resource.title}
      </div>
    </li>
  `)

export const CalendarRescheduleConfirmationModalBody = (appt, multiResourceData, calendarResources) => {
  const originalDuration = Math.abs(moment(appt.oldEvent.startStr).diff(appt.oldEvent.endStr, 'minutes'));
  const updatedDuration = Math.abs(moment(appt.event.startStr).diff(appt.event.endStr, 'minutes'));
  const oldResourceName = multiResourceData.oldEventResourceIds.map(iD => calendarResources.filter(r => r.id === iD)[0].title);
  const newResourceName = multiResourceData.newEventResourceIds.map(iD => calendarResources.filter(r => r.id === iD)[0].title);

  let adjustmentHTML = ``;
  
  if (!multiResourceData.resourceChanged) {
    // Appointment same Resource
      if (moment(appt.oldEvent.startStr).diff(appt.event.startStr, 'minutes')) {
        // Appointment startTime changed
        adjustmentHTML = `
          You are about to reschedule this <span>${appt.event.extendedProps.serviceName}</span> from 
          <span>${OnSchedHelpers.FormatRescheduleByDateSpan(appt.oldEvent.start, appt.event.start).from}</span>
          to 
          <span>${OnSchedHelpers.FormatRescheduleByDateSpan(appt.oldEvent.start, appt.event.start).to}</span>
        `;
      }
      else if (originalDuration !== updatedDuration) {
        // Appointment duration changed
        adjustmentHTML = `
          You are about to change the duration of this <span>${appt.event.extendedProps.serviceName}</span> from 
          <span>${moment(appt.oldEvent.endStr).diff(appt.oldEvent.startStr, 'minutes')} min</span> to 
          <span>${moment(appt.event.endStr).diff(appt.event.startStr, 'minutes')} min</span>
        `;
      }
  }
  else {
    // Appointment changed Resource
    if (moment(appt.oldEvent.startStr).diff(appt.event.startStr, 'minutes')) {
      // Appointment startTime changed
      adjustmentHTML = `
        You are about to reschedule this <span>${appt.event.extendedProps.serviceName}</span>
        from <span>${OnSchedHelpers.FormatRescheduleByDateSpan(appt.oldEvent.start, appt.event.start).from}</span>
        with <span>${oldResourceName}</span>
        to <span>${OnSchedHelpers.FormatRescheduleByDateSpan(appt.oldEvent.start, appt.event.start).to}</span>
        with <span>${newResourceName}</span>
      `;
    }
    else {
      // Resource Re-assigned
      adjustmentHTML = `
        You are about to re-assign this <span>${appt.event.extendedProps.serviceName}</span>
        from <span>${oldResourceName}</span>
        to <span>${newResourceName}</span>
      `;

    }
  }

  if (multiResourceData.multiResource) {
    adjustmentHTML += `<br></br><p>This booking has multiple Resources, ${multiResourceData.resourceNamesAffectedHTML} will receive a notification to inform them of the change.</p>`
  }

  return `
    <div id="onsched-full-calendar-confirmation-modal" class="onsched-full-calendar-confirmation-modal">
      <div class="onsched-full-calendar-modal-body">
        <div class="onsched-full-calendar-modal-header">
          <h5>Reschedule Appointment</h5>
        </div>

        <p>${adjustmentHTML}</p>

        <div class="onsched-full-calendar-modal-footer">
          <button type="button" id="onsched-full-calendar-close-btn" class="btn">Cancel</button>
          <button type="submit" id="onsched-full-calendar-submit-btn" class="btn btn-primary">Continue</button>
        </div>
      </div>
    </div>
  `
}

export const CalendarCancelModalBody = (appt, calendar) => `
  <div id="onsched-full-calendar-cancellation-modal" class="onsched-full-calendar-cancellation-modal">
    <div class="onsched-full-calendar-modal-body">
      <div class="onsched-full-calendar-modal-header">
        <h5>Cancel Appointment</h5>
      </div>

      <p>
        You are about to cancel the your <span>${appt.duration} min ${appt.serviceName}</span> on <span>${moment(appt.startDateTime).tz(calendar.currentData.dateEnv.timeZone === 'local' ? moment.tz.guess() : calendar.currentData.dateEnv.timeZone).format('LLLL')}</span>.
      </p>

      <div class="onsched-full-calendar-modal-footer">
        <button type="button" id="onsched-full-calendar-close-btn" class="btn">Cancel</button>
        <button type="submit" id="onsched-full-calendar-submit-btn" class="btn btn-primary">Continue</button>
      </div>
    </div>
  </div>
`

export const CalendarRemoveBlockModalBody = (block, calendar) => `
  <div id="onsched-full-calendar-cancellation-modal" class="onsched-full-calendar-cancellation-modal">
    <div class="onsched-full-calendar-modal-body">
      <div class="onsched-full-calendar-modal-header">
        <h5>Cancel Appointment</h5>
      </div>

      <p>
        You are about to cancel your <span>${block.reason?.length ? block.reason : 'block'}</span> on <span>${moment(block.startDate).tz(calendar.currentData.dateEnv.timeZone === 'local' ? moment.tz.guess() : calendar.currentData.dateEnv.timeZone).format('LL')}</span>.
      </p>

      <div class="onsched-full-calendar-modal-footer">
        <button type="button" id="onsched-full-calendar-close-btn" class="btn">Cancel</button>
        <button type="submit" id="onsched-full-calendar-submit-btn" class="btn btn-primary">Continue</button>
      </div>
    </div>
  </div>
`

export const CalendarConfirmModalBody = (appt, calendar) => `
  <div id="onsched-full-calendar-cancellation-modal" class="onsched-full-calendar-cancellation-modal">
    <div class="onsched-full-calendar-modal-body">
      <div class="onsched-full-calendar-modal-header">
        <h5>Confirm Appointment</h5>
      </div>

      <p>
        You are about to confirm your <span>${appt.duration} min ${appt.serviceName}</span> on <span>${moment(appt.startDateTime).tz(calendar.currentData.dateEnv.timeZone === 'local' ? moment.tz.guess() : calendar.currentData.dateEnv.timeZone).format('LLLL')}</span>.
      </p>

      <div class="onsched-full-calendar-modal-footer">
        <button type="button" id="onsched-full-calendar-close-btn" class="btn">Cancel</button>
        <button type="submit" id="onsched-full-calendar-submit-btn" class="btn btn-primary">Continue</button>
      </div>
    </div>
  </div>
`

export const CalendarRescheduleModalBody = () => `
  <div id="onsched-full-calendar-reschedule-modal" class="onsched-full-calendar-reschedule-modal">
    <div class="onsched-full-calendar-modal-body">
      <div class="onsched-full-calendar-modal-header">
        <h5>Reschedule Appointment</h5>
      </div>

      <div id="calendar-reschedule-availability-element"></div>

      <div class="onsched-full-calendar-modal-footer">
      </div>
    </div>
  </div>
`

export const CalendarCreateAppointmentModalBody = (element, appointments) => {
  return `
    <div id="onsched-full-calendar-modal" class="onsched-full-calendar-modal onsched-full-calendar-create-modal">
      <form id="onsched-full-calendar-modal-body" class="onsched-full-calendar-modal-body onsched-full-calendar-create-modal-body onsched-form">
        ${element.options.createResourceBlocks ? `
          <div class="onsched-form-row">
            <div class="onsched-form-col">
              <div id="onsched-full-calendar-create-modal-options">
                <label class="selected" data-input="appointment">
                  <input type="radio" value="appointment" name="eventType" checked />
                  Appointment
                </label>
                <label data-input="block">
                  <input type="radio" value="block" name="eventType" />
                  Out of office
                </label>
              </div>
            </div>
          </div>
        ` : ''}
        
        <div class="selected" data-display="appointment">
          <div class="onsched-form-row">
            <div class="onsched-form-col">
              <label for="service">Service</label>
              <div class="onsched-select">
                <select name="service">
                  ${appointments.services.map(s => 
                    `<option data-name="${s.name}" data-duration="${s.duration}" data-durationselect="${s.durationSelect}" data-durationmin="${s.durationMin}" data-durationmax="${s.durationMax}" data-durationinterval="${s.durationInterval}" value="${s.id}">${s.name}</option>`
                    )}
                </select>
              </div>
            </div>
          </div>
          <div class="onsched-form-row">
            <div class="onsched-form-col">
              <div id="onsched-calendar-popup-duration" class="hide">
                <label for="duration">Duration</label>
                <div class="onsched-select">
                  <select name="duration">
                    <option />
                  </select>
                </div>
              </div>
            </div>
          </div>
          
          <div class="onsched-form-row">
            <div class="onsched-form-col">
              <p id="onsched-create-appointment-preview"></p>
            </div>
          </div>
        </div>
        <div data-display="block">
          ${calendarCreateOutOfOffice(appointments.appt.dateStr)}
        </div>

        <div class="onsched-full-calendar-modal-footer">
          <button id="onsched-full-calendar-close-btn" type="button" class="btn">Cancel</button>
          <button type="submit" class="btn btn-primary">Create</button>
        </div>
      </form>
    </div>
  `
}

const calendarCreateOutOfOffice = (dateStr, existingBlock) => {
  const weekly = existingBlock?.repeats && existingBlock.repeat.frequency === "W" ? true : false
  const findStart = time => {
    if (!existingBlock) {
      return time[0] === parseInt(moment(dateStr).format('Hmm'));
    }
    else {
      return time[0] === existingBlock.startTime;
    }
  }
  
  const findEnd = time => {
    if (!existingBlock) {
      return time[0] === parseInt(moment(dateStr).add(30, 'minutes').format('Hmm'));
    }
    else {
      return time[0] === existingBlock.endTime;
    }
  }
  return `
    <div class="onsched-form-row">
      <div class="onsched-form-col">
        <div class="onsched-select">
          <select name="startTime">
            ${OnSchedTemplates.initTimesSelectData("en-US").map(time => 
                `<option key="${time[0]}" ${findStart(time) ? 'selected' : ''} value="${time[0]}">${time[1]}</option>`
            ).join('')}
          </select>
        </div>
      </div>
      <div class="onsched-form-col">
        <div class="onsched-select">
          <select name="endTime">
            ${OnSchedTemplates.initTimesSelectData("en-US").map(time => 
                `<option key="${time[0]}" ${findEnd(time) ? 'selected' : ''} value="${time[0]}">${time[1]}</option>`
            ).join('')}
          </select>
        </div>
      </div>
    </div>
    <div class="onsched-form-row">
      <div class="onsched-form-col">
        <input type="text" placeholder="Reason (e.g. Out of office)" name="reason" value="${existingBlock ? existingBlock.reason : ''}" />
      </div>
    </div>
    <div class="onsched-form-row">
      <div class="onsched-form-col">
        <label class="onsched-radio">
          <input type="checkbox" name="repeats" ${existingBlock && existingBlock.repeats ? 'checked' : ''} />
          Repeats
        </label>
      </div>
      <div class="onsched-form-col">
        <div class="onsched-select">
          <select name="frequency" ${existingBlock?.repeats ? '' : 'disabled="disabled"'}>
            <option ${existingBlock?.repeats && existingBlock.repeat.frequency === "D" ? 'selected' : ''} value="D">Daily</option>
            <option ${existingBlock?.repeats && existingBlock.repeat.frequency === "W" ? 'selected' : ''} value="W">Weekly</option>
            <option ${existingBlock?.repeats && existingBlock.repeat.frequency === "M" ? 'selected' : ''} value="M">Monthly</option>
          </select>
        </div>
      </div>
      </div>
      <div id="onsched-blocks-repeat-weekdays" style="${weekly ? '' : 'display: none;'}" class="onsched-form-row">
      <div class="onsched-form-col">
        <div class="onsched-repeat-weekdays">
          ${
            ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'].map((weekday, i) => 
              `<label for="blocks-repeat-weekly-${weekday}" class="onsched-radio">
                <input id="blocks-repeat-weekly-${weekday}" type="checkbox" ${weekly && existingBlock.repeat.weekdays.includes(i) ? 'checked' : ''} name="repeat-weekly-${weekday}" />
                ${weekday.slice(0,3)}
              </label>`
            ).join("")
          }
        </div>
      </div>
    </div>
    <div id="onsched-blocks-end-date" class="onsched-form-row" style=" ${existingBlock?.repeats ? '' : 'style="opacity:.4;"'}">
      <div class="onsched-form-col">
        <label>Ending</label>
        <input name="endDate" type="date" ${existingBlock?.repeats ? '' : 'disabled="disabled"'} value="${moment(existingBlock ? existingBlock.endDate : dateStr).format('YYYY-MM-DD')}" />
      </div>
    </div>

    <input type="hidden" name="startDate" value="${moment(dateStr).format('YYYY-MM-DD')}" />

    <div class="onsched-full-calendar-modal-footer">
      <button type="submit" class="btn-primary hide">Save</button>
    </div>
  `
}

export const CalendarCreateAppointmentInitialModalBody = appointment => `
  <div id="onsched-full-calendar-modal" class="onsched-full-calendar-modal onsched-full-calendar-create-modal">
    <form id="onsched-full-calendar-create-appointment-modal-body" class="onsched-form onsched-full-calendar-modal-body onsched-full-calendar-create-modal-body">
      <div class="onsched-full-calendar-modal-header-confirmed-container">
        <header class="onsched-popup-header">This booking will expire in <span id="onsched-calendar-timer-container"></span></header>
        
        <div class="onsched-full-calendar-modal-header">
          <button type="button" id="onsched-full-calendar-close-btn" class="onsched-primary-color-hover onsched-background-background-color onsched-dark-color">
            <i class="fal fa-times"></i>
          </button>
        </div>
      </div>
      <div class="onsched-form-row">
        <div class="onsched-form-col">
          <input id="onsched-field-firstname" type="text" name="firstname" autofocus placeholder="First Name" required>
        </div>
        <div class="onsched-form-col">
          <input id="onsched-field-lastname" type="text" name="lastname" placeholder="Last Name" required>
        </div>
      </div>
      
      <div class="hide" id="onsched-calendar-customer-search-results-lastname"></div>

      <div class="onsched-form-row">
        <div class="onsched-form-col">
          <input id="onsched-field-email" type="email" name="email" placeholder="Email" pattern="[a-z0-9._%+-]+@[a-z0-9-]+\.[a-z]{2,}$" required>
        </div>
      </div>

      <div class="hide" id="onsched-calendar-customer-search-results-email"></div>

      <div class="onsched-form-row">
        <div class="onsched-form-col">
          <input type="phone" name="phone" placeholder="Phone" pattern="^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$" title="Must be a valid phone number" />
        </div>
      </div>
      <div class="onsched-form-row">
        <div class="onsched-form-col">
          <input type="text" name="location" placeholder="Location or Meeting Link" />
        </div>
      </div>
      
      ${calendarAppointmentBookingFields(appointment.appointmentBookingFields)}
      
      <div class="onsched-form-row">
        <div class="onsched-form-col">
          <textarea name="customerMessage" placeholder="Notes"></textarea>
        </div>
      </div>

      <div class="onsched-full-calendar-modal-footer">
        <button id="onsched-full-calendar-cancel-btn" type="button" class="btn">Cancel</button>
        <button type="submit" class="btn btn-primary">Create</button>
      </div>
    </form>
  </div>
`

const calendarAppointmentBookingFields = (fields) => {
  const createInput = field => {
    let fieldHtml = ''

    if (field.fieldType === 'string') {
      fieldHtml = `<input type="text" placeholder="${field.fieldLabel}" ${field.fieldRequired ? 'required' : ''} name="${field.fieldName}" />`
    }
    else if (field.fieldType === 'int') {
      fieldHtml = `
        <div class="onsched-select">
          <select name="${field.fieldName}" ${field.fieldRequired ? 'required' : ''}>
            <option selected="true" disabled="disabled" value="">${field.fieldLabel}</option>
            ${field.fieldListItems.map(item => `<option value="${item.value}">${item.name}</option>`).join('')}
          </select>
        </div>
      `
    }

    return fieldHtml
  }

  return `
    ${fields.map((field, idx) => {
      return`
      ${!(idx % 2) ? `
        <div class="onsched-form-row">
          <div class="onsched-form-col">
            ${createInput(field)}
      ` : `
          </div>
          <div class="onsched-form-col">
            ${createInput(field)}
          </div>
        </div>
      `}
    `}).join('')}
    ${fields.length % 2 ? '</div></div>' : ''}
`
}

export const CalendarBlockModalBody = (element, response) => `
  <div id="onsched-full-calendar-modal" class="onsched-full-calendar-modal">
    <form id="onsched-full-calendar-modal-body" class="onsched-full-calendar-modal-body onsched-form">
      <div class="onsched-full-calendar-modal-header">
        <div class="onsched-calendar-appointment-actions-container">
          <button type="button" id="onsched-calendar-block-remove-button" title="Remove Block">
            <i class="fal fa-trash"></i>
          </button>
        </div>

        <button type="button" id="onsched-full-calendar-close-btn" class="onsched-primary-color-hover onsched-background-background-color onsched-dark-color">
          <i class="fal fa-times"></i>
        </button>
      </div>
      
      ${calendarCreateOutOfOffice(new Date(response.startDate).toISOString(), response)}
    </form>
  </div>
`

export const CalendarAppointmentModalBody = (appointments, element, e) => {
  const { appt, services, service, resources } = appointments;
  // To support multiselect resource dropdown add the following code to template:
  //
  // <select multiple multiselect-search="true" multiselect-select-all="true">
  //   ${allResources?.map(r => `
  //     <option ${resources.map(res => res.id).filter(resId => resId === r.id).length ? 'selected="selected"' : ''} value="${r.id}" data-id="${r.id}">${r.name}</option>
  //   `).join('')}
  // </select>

  const createAppt = e.event ? false : true;

  // const form = OnSchedHelpers.ViewAppointmentForm(appt);
  const urlRegex = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;
  
  let title = '';

  if (createAppt) {
    title = 'New Appointment'
  }
  else {
    title = appt.serviceName + " | " + appt.firstname + ' ' + appt.lastname;
    if (OnSchedHelpers.IsEmpty(appt.firstname) && OnSchedHelpers.IsEmpty(appt.lastname)) {
      title = appt.serviceName + " | " + appt.email;
    }
  
    // Customize event title HTML based on element parameters
    if (!OnSchedHelpers.IsEmpty(element.params.eventTitle)) {
      if (Object.prototype.toString.call(element.params.eventTitle) === '[object String]') {
        title = OnSchedHelpers.ReplaceParameterValues(element.params.eventTitle, appt);
      }
      else if (Object.prototype.toString.call(element.params.eventTitle) === '[object Object]') {
        if (element.params.eventTitle.html) {
          let tmp = document.createElement("DIV");
          tmp.innerHTML = element.params.eventTitle.html;
          title = OnSchedHelpers.ReplaceParameterValues(tmp.innerText, appt);
        }
      }
    }
  }

  // Configure Time Zone based on element params
  let formattedStart = moment(createAppt ? e.dateStr : appt.startDateTime);
  let formattedEnd = moment(createAppt ? moment(e.dateStr).add(service.duration, 'minutes').format() : appt.endDateTime);

  // let formattedEnd = moment(e.event.startStr).add(appt.duration, 'minutes');
  // if (createAppt) formattedEnd = moment(appt.endDateTime);

  const timeZone = createAppt ? e.view.dateEnv.timeZone : e.event._context.options.timeZone;
  
  if (!createAppt && timeZone !== 'local') {
    formattedStart = formattedStart.tz(timeZone);
    formattedEnd = formattedEnd.tz(timeZone);
  }

  let name = appt.name
  if (!name.length) {
    name = appt.firstname + ' ' + appt.lastname
  }
  if (!name.length) {
    name = '<span style="font-style:italic;">No name provided</span>'
  }

  return `

  <div id="onsched-full-calendar-modal" class="onsched-full-calendar-modal">
      <form id="onsched-full-calendar-modal-body" class="onsched-full-calendar-modal-body">
        <div class="onsched-full-calendar-modal-header-confirmed-container">
          <div class="onsched-full-calendar-modal-header-confirmed">
            ${appt.confirmed ? `
              <i class="far fa-check-circle"></i>
              Confirmed
            ` : ''}
          </div>
          <div class="onsched-full-calendar-modal-header">
            <div class="onsched-calendar-appointment-actions-container">
              <div style="display:none" id="onsched-calendar-appointment-actions">
                <button class="btn" data-appointment-action="cancel">Cancel</button>
                <button class="btn" data-appointment-action="confirm" ${appt.confirmed ? 'disabled="disabled"' : ''}>Confirm</button>
              </div>
              <button type="button" id="onsched-calendar-appointment-actions-btn">
                <i class="fal fa-ellipsis-v-alt"></i>
              </button>
            </div>

            <button type="button" id="onsched-full-calendar-close-btn" class="onsched-primary-color-hover onsched-background-background-color onsched-dark-color">
              <i class="fal fa-times"></i>
            </button>
          </div>
        </div>

        <table>
          <tbody>
            <tr>
              <td>
                <i class="fal fa-clock"></i>
              </td>
              <td>
                <h1>${title}</h1>
                <div class="onsched-calendar-appointment-date-time">
                  <h5>
                    <span data-hide="mobile">${formattedStart.format('dddd, MMM D')}</span>
                    <span data-hide="desktop">${formattedStart.format('ddd, MMM D')}</span>
                  
                    ${formattedStart.format('h:mma')} &#8212; ${formattedEnd.format('h:mma')}
                  </h5>
                </div>
              </td>
            </tr>
            ${appt?.location?.length ? `
              <tr title="Appointment Location">
                <td>
                  <i class="fal fa-map-marker-alt"></i>
                </td>
                <td>
                    ${appt.location.match(urlRegex) ? `<a target="_blank" href="${appt.location}">${appt.location}</a>` : appt.location}
                </td>
              </tr>
            ` : ''}
            <tr title="Customer" class="onsched-form">
              <td>
                <i class="fal fa-user-circle"></i>
              </td>
              <td>
                <div class="onsched-calendar-appointment-modal-customer-copy">
                  ${name}

                  <div>
                    <button title="Copy Email Address" data-copy="${appt.email}" style="padding:5px 10px;border-radius:50%">
                      <i class="fal fa-envelope"></i>
                    </button>
                    ${appt.phone?.length ? `
                      <button title="Copy Phone Number" data-copy="${appt.phone}" style="padding:5px 10px;border-radius:50%">
                        <i class="fal fa-phone"></i>
                      </button>
                    ` : ''}
                  </div>
                </div>
              </td>
            </tr>
            <tr title="Resource" class="onsched-form">
              <td>
                <i class="fal fa-users"></i>
              </td>
              <td>
                ${resources.length > 1 ? `<span class="resources-count">${resources.length} Resources</span>` : ''}
                ${resources.map(r => `
                  <div class="${resources.length > 1 ? 'multi-resource-list-item' : 'resource-list-item'}">
                    ${ !r.resourceImageUrl ?
                      `<div class="resource-icon">${OnSchedTemplates.circleIcon(r.resourceName)}</div>` : 
                      `<div class="resource-icon">${OnSchedTemplates.listImage(r.resourceImageUrl)}</div>`
                    }
                    ${r.resourceName}
                  </div>
                `).join('')}
              </td>
            </tr>
            <tr title="Service" class="onsched-form">
              <td>
                <i class="fal fa-hand-holding-usd"></i>
              </td>
              <td>
                <div>
                  ${appt.serviceName} &#8212; ${OnSchedHelpers.FormatDuration(appt.duration)}
                </div>
              </td>
            </tr>
            <tr title="Customer Message">
              <td>
                <i class="fal fa-comment-lines"></i>
              </td>
              <td>
                ${!OnSchedHelpers.IsEmpty(appt.customerMessage) ? `<p>${appt.customerMessage}</p>` : '<p style="font-style:italic;opacity:.7">No customer message provided</p>'}
                </p>
              </td>
            </tr>

            ${appt.customFields?.field1 || createAppt && appt.customFields?.length ? `
              <tr title="Custom Fields">
                <td>
                  <i class="fal fa-tasks-alt"></i>
                </td>
                <td>
                  <table class="onsched-calendar-custom-fields">
                    <tbody>
                      <tr>
                      ${
                        appt.customFields ? 
                          Object.values(appt.customFields)
                            .map((field, i) => `<td>${field.name}: ${field.value?.length ? field.value : '<span style="font-style:italic;opacity:.7">No value provided</span>'}</td>`)
                            .join('</tr><tr>')
                        :
                        ''
                      }
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            ` : ''}
            <tr title="Audit Trail">
              <td>
                <i class="fal fa-fingerprint"></i>
              </td>
              <td>
                ${
                  appt.auditTrail? 
                    Object.values(appt.auditTrail)
                      .map(trail => `<div style="font-size:.7rem" class="audit-trail-row"><i class="fal fa-caret-right"></i> ${trail.modificationType} | ${trail.statusBefore} - ${trail.statusAfter} | ${moment(trail.modifiedOn).format('YYYY-MM-DD')} | ${trail.modifiedBy}</div>`)
                      .join('')
                  : ''
                }
              </td>
            </tr>
          </tbody>
        </table>
      </form>
    </div>
  `
}

export const CalendarToast = toast => `
  <div>
    <p>${toast.message}</p>
  </div>
  <i class="fas fa-${toast.icon}"></i>
`

export const ServiceSelectedInfo = selected => {
  var tmpl;

  if (selected) {
    // Update info from selected
      // Determine if duration select true
      if (selected.durationSelect) {
        tmpl = `Booking a <span>${selected.durationMin} - ${selected.durationMax} min</span> ${selected.name}`;
      }
      else {
        tmpl = `Booking a <span>${selected.duration} min</span> ${selected.name}`;
      }
  }
  else {
    // Throw Error
  }

  return tmpl;
}

const ResourceIcons = resources => `
  ${resources.map(r => `
    <div
      class="onsched-resource-chip"
      data-id="${r.resourceId}"
      data-name="${r.resourceName}"
    >
      ${r.resourceName}
    </div>
  `).join(', ')}
`

export const CalendarPaginationBody = (pages, active) => `
  ${Array.from({length: pages}, (_, i) => i + 1)
    .map(p => `
      <div 
        class="onsched-pagination-page-number${parseInt(p) === parseInt(active) ? ' active' : ''}" 
        data-page="${p}">
          ${p}
        </div>
    `).join('')
  }
`
